<!-- 热门课程榜单列表-->
<template>
  <div :class="['hotSale-index', { inApp: $root.$data.isApp||$root.miniprogram }]">
    <common-title
      titleName="课程列表"
      :bcColor="'#FEFEFF'"
      :zIndex="1000"
    ></common-title>
    <template v-if="!listEmpty">
      <HotSaleSwiper
        v-if="hotList.length"
        :hotList="hotList"
      />
      <div class="course-list">
        <h3 class="hotListTitle">课程榜单</h3>
        <div
          v-for="(item, keys) in courseInfoData"
          :key="keys"
          @click="goback()"
        >
          <CombinationCard
            v-if="item.setType === 1"
            :key="keys"
            :item="item"
          />
          <HotCourseCard
            v-else
            :key="keys"
            :item="item"
          />
        </div>

      </div>
    </template>
    <EmptyData
      :emptyName="'noProductList'"
      v-if="listEmpty"
    />
    <Foot />
  </div>
</template>

<script>
import HotCourseCard from '@/components/hotCourseCard/hotCourseCard.vue';
import CombinationCard from '@/components/combinationCard/combinationCard.vue';
// eslint-disable-next-line import/no-cycle
import { reqCombinationlist } from '@/api/combination';
// eslint-disable-next-line import/no-cycle
import { reqMajorAd, reqProducts, reqHotEvaluation } from '@/api/home';
import EmptyData from '@/components/emptyData/emptyData.vue';
import Foot from '@/components/foot/privacy.vue';
import { resetProductData, resetCoursePackage } from '@/utils/tools';
import HotSaleSwiper from './components/hotSaleSwiper';

export default {
  data() {
    return {
      courseInfoData: [],
      ids: [],
      listEmpty: false,
      hotList: [],
    };
  },

  components: {
    HotCourseCard,
    CombinationCard,
    EmptyData,
    Foot,
    HotSaleSwiper,
  },

  computed: {
  },
  created() {
    document.documentElement.scrollTop = 0;
    window.pageYOffset = 0;
    document.body.scrollTop = 0;
  },
  mounted() {
    this.getProductEvaluation();
    this.getCourseAd();
    // if (this.$root.$data.isApp) {
    //   this.getCourseAd();
    // } else {
    //   const list = sessionStorage.getItem('HOTSALELIST');
    //   this.courseInfoData = JSON.parse(list);
    //   if (!this.courseInfoData.length) {
    //     this.listEmpty = true;
    //   }
    // }
  },
  destroyed() {
  },
  methods: {
    goback() {
      sessionStorage.setItem('back', true);
    },
    // 获取热销产品评价轮播
    async getProductEvaluation() {
      const res = await reqHotEvaluation();
      this.hotList = res?.data?.data;
    },
    // 查询广告位
    async getCourseAd() {
      const { code, data } = await reqMajorAd(this.$route.query.recommendId);
      if (code === 0 && data?.length) {
        const { recommendContentVOList } = data[0];
        this.getMajorList(recommendContentVOList);
      } else {
        this.listEmpty = true;
      }
    },
    // 查询课程卡片信息
    async getMajorList(recommendContentVOList) {
      const allProductIds = [];
      const allPackageIds = [];
      (recommendContentVOList || []).forEach((child) => {
        if (child.recommendType === 0) {
          allProductIds.push(child.productId);
        } else {
          allPackageIds.push(child.productId);
        }
      });
      const endPoint = this.$root.$data.isApp ? 2 : 4;
      const p1 = allProductIds.length ? reqProducts(allProductIds, endPoint) : {};
      const p2 = allPackageIds.length ? reqCombinationlist(0, endPoint, allPackageIds) : {};

      Promise.all([p1, p2]).then((result) => {
        const res = result[0];
        const res1 = result[1];
        const resCourse = resetProductData(res?.data || []);
        const resPackage = resetCoursePackage(res1?.data || []);
        const allCourse = [];
        recommendContentVOList.forEach((child) => {
          const findRes = [...resCourse, ...resPackage].find((course) => {
            const id = child.recommendType === 0 ? course.productId : course.packageId;
            return id === child.productId;
          });
          // eslint-disable-next-line no-unused-expressions
          findRes && allCourse.push(findRes);
        });
        this.courseInfoData = allCourse;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.hotSale-index {
  width: 100%;
  min-height: 100%;
  padding-top: 120px;
  &.inApp {
    padding-top: 20px;
  }

  .course-list {
    padding: 40px;
    .hotListTitle {
      margin-bottom: 32px;
      color: #111;
      font-weight: 500;
      font-size: 32px;
      line-height: 44px;
    }
  }
}

::v-deep .topType {
  display: none;
}

::v-deep .common-foot {
  position: relative;
}
</style>
